export default function NoInvoiceSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66" fill="none">
      <path
        d="M2.50002 15.7L8.70002 60.6C9.00002 62.8 11 64.3 13.2 64L43.9 59.8C46.1 59.5 47.6 57.5 47.3 55.3V55C46.9 55.1 46.5 55.2 46 55.2H15C12.8 55.2 11 53.4 11 51.2V10.5L5.90002 11.2C3.70002 11.5 2.20002 13.5 2.50002 15.7Z"
        fill="#EF6561"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.8 6C49.8 3.8 48 2 45.8 2H14.8C12.6 2 10.8 3.8 10.8 6V51.3C10.8 53.5 12.6 55.3 14.8 55.3H45.8C48 55.3 49.8 53.5 49.8 51.3V6Z"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.6 12.5998C63.6 17.4998 59.6 21.4998 54.7 21.4998C52.9 21.4998 51.3 20.9998 49.9 20.0998L45.8 20.8998L46.6 16.3998C46.1 15.2998 45.8 13.9998 45.8 12.6998C45.8 7.7998 49.8 3.7998 54.7 3.7998C59.6 3.7998 63.6 7.6998 63.6 12.5998Z"
        fill="#60A5FA"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.1 16.5999C52.7 16.5999 52.3 16.3999 52 16.1999L50.2 14.3999C49.6 13.7999 49.6 12.8999 50.2 12.2999C50.8 11.6999 51.7 11.6999 52.3 12.2999L53 12.9999L57 9.0999C57.6 8.4999 58.5 8.4999 59.1 9.0999C59.7 9.6999 59.7 10.5999 59.1 11.1999L54.2 16.0999C53.9 16.3999 53.5 16.5999 53.1 16.5999Z"
        fill="white"
      />
      <path
        d="M43.9 48L40.3 44.4L59.6 25C60.1 24.5 60.9 24.5 61.5 25L63.3 26.8C63.8 27.3 63.8 28.1 63.3 28.7L43.9 48Z"
        fill="#60A5FA"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.2 44.3999L38.4 49.7999L43.9 47.9999"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57 27.6001L60.7 31.2001"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 10.4001L18.1 12.5001L23.5 7.1001"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 21.9L22.4 16.5"
        stroke="#EF6561"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.4 21.9L17 16.5"
        stroke="#EF6561"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 40.6998L22.4 35.2998"
        stroke="#EF6561"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.4 40.6998L17 35.2998"
        stroke="#EF6561"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 29.1999L18.1 31.2999L23.5 25.8999"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 47.9002L18.1 50.1002L23.5 44.7002"
        stroke="#60A5FA"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6 7.7002H35.2"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6 12H40"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6 17.1001H35.2"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6 21.3999H40"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6 26.5H35.2"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6 30.7998H44.7"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6 35.8999H35.2"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6 40.1997H37.6"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6 45.2998H35.2"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6 49.5996H33.6"
        stroke="#101F2D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
